import { render, staticRenderFns } from "./upload-list-picture.vue?vue&type=template&id=2867a188&"
import script from "./upload-list-picture.vue?vue&type=script&lang=js&"
export * from "./upload-list-picture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports